export const STORAGE_KEYS = {
	accessToken: 'accessToken',
	refreshToken: 'refreshToken',
	deviceIdentifier: 'deviceIdentifier',
	activeProjects: 'activeProjects',
	activeProjectGroups: 'activeProjectGroups',
	activeLicenses: 'activeLicenses',
	testMode: 'testMode',
};
